var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTrendDecrease(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21214D",
    d: "M12.64 3.415c.19-.021.36.149.36.36v8.871c0 .212-.149.36-.36.36H3.77c-.213 0-.383-.17-.362-.36l-.02-.828c0-.212.169-.382.36-.36l6.6-.022L3.11 4.2a.347.347 0 0 1 0-.509l.595-.594a.365.365 0 0 1 .509 0l7.236 7.236V3.755c-.021-.191.149-.361.36-.361l.828.021Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrendDecrease);
export default __webpack_public_path__ + "static/media/icon-trend-decrease.0101da8a66fabb06b1547395331f9234.svg";
export { ForwardRef as ReactComponent };